const $body = $('body')
const $html = $('html')
const $videoModal = $('.modal-video')
const $video = $('#video-src')
const $video_iframe = $('#video-src-youtube')

$body.on('click', '[data-video-src]', function (e) {
  e.preventDefault()
  let src = $(this).data('video-src')
  let is_youtube = $(this).data('is-youtube')

  if (is_youtube) {
    src = 'https://www.youtube.com/embed/' + ytUrlToCode(src)+'?autoplay=1&muted=1';
  }

  openVideoModal(src, is_youtube)
})

function ytUrlToCode(link = '') {
  try {
    const url = new URL(link);
    const queryParams = new URLSearchParams(url.search);

    if (queryParams.has('v')) {
      return queryParams.get('v');
    } else if (queryParams.has('vi')) {
      return queryParams.get('vi');
    }

    const pathParts = url.pathname.split('/').filter(part => part);
    if (pathParts.length > 0) {
      return pathParts[pathParts.length - 1];
    }
  } catch (e) {
    console.error('Invalid URL:', e);
  }
  return null;
}


$body.on('click', '.modal-video-close', function (e){
  e.preventDefault()
  hideVideoModal()
})

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    hideVideoModal()
  }
})

function hideVideoModal() {
  $videoModal.removeClass('modal-visible')
  $html.removeClass('modal-visible')
  $video.attr('src', '')
  $video_iframe.attr('src', '')
}

function historyListener(event) {
  hideVideoModal()
}

function openVideoModal(src, is_youtube = false) {

  if(is_youtube) {
    $video.addClass('hidden')
    $video_iframe.removeClass('hidden')
    $video_iframe.attr('src', src)
  } else {
    $video_iframe.addClass('hidden')
    $video.removeClass('hidden')
    $video.attr('src', src)
  }

  setTimeout(function() {
    $video[0].play()
    $videoModal.addClass('modal-visible')
    $html.addClass('modal-visible')
  }, 5)

}

function closeVideoModal() {

  if ( window.history.state === '#video' ) {
    history.go(-1)
  }

  window.removeEventListener('popstate', historyListener)
}
